import { useIntl } from 'react-intl';

export const useFormatText = () => {
  const intl = useIntl();
  const formatText = (
    id: string,
    values?: Record<string, string | number | boolean>
  ) => intl.formatMessage({ id }, values);

  return { formatText };
};
